import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { ISpecificationItemProps } from './types';

import * as styles from './styles.css';

export const SpecificationItem: FC<ISpecificationItemProps> = props => {
  const { text, title, icon: Icon, className } = props;

  if (!text) {
    return null;
  }

  return (
    <div className={clsx(styles['root'], className)}>
      <Icon />
      <div className={styles['description']}>
        <ArticleParagraph2 color="gray60_100">{title}</ArticleParagraph2>
        <ArticleHeading4>{text}</ArticleHeading4>
      </div>
    </div>
  );
};

SpecificationItem.displayName = 'SpecificationItem';
